import React from 'react';
import projectImage from '../img/P4.png';
import Navbar from './Navbar';
import { motion } from "framer-motion";
import { FaGithub, FaFigma } from "react-icons/fa";
import { Link } from "react-router-dom";

const Proj3 = () => {
  return (
    <div>
      <Navbar />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        id='about'
        className="mx-auto px-4 md:px-20"
      >
        <h2 className="text-4xl sm:text-4xl font-bold pl-4 pt-20">Project Title: Student Section Portal (Internship Project)</h2>

        <div className="max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center h-full py-10">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="h-75 w-75 ml-4 mr-4 pr-4"
          >
            <img
              src={projectImage}
              alt="Project Screenshot"
              className="mx-auto w-full shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col justify-center h-full "
          >
            <div className="items-center justify-center">
              <h2 className="text-3xl sm:text-4xl font-bold pl-4">Key tools and technologies:</h2>
              <ul className="flex flex-wrap justify-center pb-5 text-xl sm:text-2xl font-bold pt-2">
                <li className="pl-4">HTML5</li>
                <li className="pl-4">CSS3</li>
                <li className="pl-4">React JS</li>
                <li className="pl-4">Bootstrap</li>
              </ul>
            </div>

            <div className="items-center justify-center">
              <ul className="flex justify-center pb-10 text-xl sm:text-2xl font-bold">
                <li className="pl-4">Node JS</li>
                <li className="pl-4">MongoDB</li>
                <li className="pl-4">NodeMailer</li>
                <li className="pl-4">Express</li>
              </ul>
            </div>

            <div className="items-center justify-center">
              <ul className="flex justify-center pb-10">
                <li className="pl-4">
                  <Link to="https://github.com/45aman/front-end-mit"><FaGithub size="3.3rem" /></Link>
                  Frontend Content
                </li>
                <li className="pl-4">
                  <Link to="https://github.com/45aman/Backend-mit"><FaGithub size="3.3rem" /></Link>
                  Backend Content
                </li>
                <li className="pl-4">
                  <Link to="https://www.figma.com/file/xnRy29ZM5Sd6AU5rOp7x6i/MIT-WPU?type=design&t=dBj1ONBw9HXJd46b-6"><FaFigma size="3.3rem" /></Link>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        <h1 className="text-4xl sm:text-3xl font-bold pt-10 pl-4">Project Description:</h1>
        <div className="px-4 md:px-20">
          <p className="py-4">
          Introducing the Online Student Section Portal - a comprehensive platform designed to streamline the document application process and enhance communication between students and staff. This dynamic web application caters to the needs of both students and staff, ensuring seamless interactions and efficient services.

<br/>For students, the portal offers a convenient way to apply for various documents, such as course completion certificates, bonafides, GPA certificates, and more. Additionally, we have dedicated a special section to cater to the needs of disabled students, allowing them to request specific accommodations or support from the college.

<br/>To optimize the resolution of student queries, we have implemented a well-organized system. Students can submit their queries, which are then collected in a batch. The staff section is equipped to fetch all relevant information from the database, enabling them to provide swift and accurate responses to student inquiries. This ensures quick service delivery, addressing student needs promptly.

<br/>Moreover, we have incorporated an efficient mail system into the portal. This feature enables seamless communication between students and staff, facilitating effective exchange of information and updates.

<br/>Additionally, we understand the importance of secure and convenient payment options. Therefore, our portal includes a robust payment system, allowing students to make payments for document applications and other college-related services seamlessly.

<br/>Through the Online Student Section Portal, we aim to create a user-friendly and inclusive platform that fosters a harmonious relationship between students and staff. The application's intuitive design and thoughtful features prioritize ease of use and accessibility.

<br/>For a more in-depth understanding of the project's functionalities, we invite you to watch the accompanying video. Experience the convenience, efficiency, and effectiveness of our Online Student Section Portal, designed to empower students and staff in their academic journey.          </p>

          <div>
            <Link to="https://drive.google.com/file/d/1rnk9rAzYqeiwhHXtuIUTiJczRqAqTfG2/view?usp=drive_link">
              <button
                type="button"
                className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
              >
                Video Link
              </button>
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Proj3;
